import React from 'react';
import PropTypes from 'prop-types';
import './style/BusyOverlay.css';

class BusyOverlay extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired
    }
    render() {
        return (
            <div className={this.props.type + "-busy-overlay busy-overlay"}>
                <span><img src="assets/spinner.gif" /><span>Attendere...</span></span>
            </div>
        );
    }
}

export default BusyOverlay;
